import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import { useRecoilValue } from 'recoil';
import { appConfigAtomState } from '../../../state/reducerAtoms/app.atom';
import AppTable from '../../../components/table/index';

import { getCurrentFacilityURL } from '../../../helpers/helper.functions';
import { checkPermissions } from '../../../utils/permissions';
import { translateThis } from '../../../helpers/language.helper';
import { DATE_FORMAT } from '../../../constants';
import PageLayout from '../../app';
import AddEditIntent from './AddEditIntent';

const IntentsList = () => {
    const appState = useRecoilValue(appConfigAtomState);
    const profile = appState?.profile || {};

    const facilityURL = getCurrentFacilityURL();
    const navigator = useNavigate();

    const tableColumns = [
        {
            title: `${translateThis('Display Name')}`,
            dataIndex: 'displayName',
            key: 'displayName',
            onCell: () => ({
                style: { minWidth: 150 },
            }),
            width: 150,
            ellipsis: true,
        },
        {
            title: `${translateThis('Name')}`,
            dataIndex: 'name',
            key: 'name',
            width: 150,
            ellipsis: true,
        },
        {
            title: `${translateThis('Module')}`,
            dataIndex: ['moduleId', 'name'],
            key: 'moduleName',
            width: 180,
            ellipsis: true,
            render: (text, record) => record?.moduleId?.name || 'Global'
        },
        {
            title: `${translateThis('Status')}`,
            dataIndex: 'status',
            key: 'status',
            width: 100,
            ellipsis: true,
        },
        {
            title: `${translateThis('Created at')}`,
            dataIndex: 'createdAt',
            key: 'createdAt',
            width: 130,
            ellipsis: true,
            render: (text, record) => dayjs(record?.createdAt).format(DATE_FORMAT)
        },
    ];

    const [isRefreshData, setIsRefreshData] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [editId, setEditId] = useState('');

    const refresh = () => {
        setIsRefreshData((prv) => !prv);
    }

    const handleEdit = (record) => {
        setEditId(record.id);
        setIsOpen(true);
    };

    const getDataURL = () => `intents`;

    return (
        <>
            {checkPermissions(profile, "See Intents") ?
                <>
                    <PageLayout
                        pageName={'Intents'}
                        pageTitle={'Intents'}
                        bodyClassName={`module-main-wrp`}
                        key={`${appState?.selectedLang}`}
                    >
                        <div className="container">
                            <div className="main-content-wrapper AI-module-list f-wrp">
                                <div className="module-list-box appTable-list f-wrp">
                                    <div className='btn-header'>
                                        <button className='create-module-btn' onClick={() => { setEditId(''); setIsOpen(true); }}>{translateThis('Create intent')}</button>
                                    </div>
                                    <AppTable
                                        columns={tableColumns}
                                        dataURL={getDataURL()}
                                        isRefreshData={isRefreshData}
                                        onRefreshSuccess={() => setIsRefreshData(false)}
                                        isEditActionEnabled
                                        isViewActionEnabled={false}
                                        isDeleteActionEnabled
                                        onEdit={handleEdit}
                                    />
                                </div>
                            </div>
                        </div>
                    </PageLayout >
                    <AddEditIntent isOpen={isOpen} setIsOpen={setIsOpen} refresh={refresh} editId={editId} />
                </>
                :
                <PageLayout
                    pageName={'No Access'}
                    pageTitle={'No Access'}
                    bodyClassName={`module-main-wrp no-access-page`}
                    key={`${appState?.selectedLang}`}
                >
                    <div className="container">
                        <div className="main-content-wrapper AI-module-list f-wrp">
                            <div className='no-access-box'>
                                <div className='no-access-title'>
                                    <h2 style={{ color: '#fff', textAlign: 'center' }}>{translateThis('No Access')}</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </PageLayout>}
        </>
    )
}

IntentsList.propTypes = {}

export default IntentsList;
